import { QUERY_RESPONSE_RECEIVED } from '@web-platform/shared-universal-constants/src/network';
import { SEARCH_PARAMS_CHANGED } from '@web-platform/shared-universal-constants/src/userSearch';
import { PRICE_PULSE } from '@web-platform/shared-universal-types/src/network/requestTypes';

import type { QueryResponseActionPricePulsePayload } from '@web-platform/shared-universal-types/src/redux/actions/actions-shared-types';
import type {
  PricePulseMap,
  PricePulseState,
} from '@web-platform/shared-universal-types/src/redux/state/flightSearchResults/pricePulse/pricePulse';

export const INITIAL_STATE: PricePulseState = { byId: {} };

type PricePulseQueryResponseAction = {
  type: 'QUERY_RESPONSE_RECEIVED';
  error: boolean;
  payload: QueryResponseActionPricePulsePayload;
};

type PricePulseAction = PricePulseQueryResponseAction | { type: string };

const isPricePulseQueryResponseAction = (
  action: PricePulseAction,
): action is PricePulseQueryResponseAction =>
  action.type === QUERY_RESPONSE_RECEIVED &&
  'payload' in action &&
  action.payload.type === PRICE_PULSE;

const byId = (state: PricePulseMap = {}, action: PricePulseQueryResponseAction): PricePulseMap => {
  switch (action.payload.type) {
    case PRICE_PULSE: {
      const { response } = action.payload;

      if (!response.headers || !response.body?.pricePulses) {
        return state;
      }

      const { pricePulses } = response.body;

      const transformedPricePulse: PricePulseMap = {};
      for (const pricePulse of pricePulses) {
        if (pricePulse.itineraryId) {
          transformedPricePulse[pricePulse.itineraryId] = pricePulse;
        }
      }

      return { ...state, ...transformedPricePulse };
    }

    default:
      return state;
  }
};

export const pricePulseReducer = (
  state: PricePulseState = INITIAL_STATE,
  action: PricePulseAction,
): PricePulseState => {
  switch (action.type) {
    case QUERY_RESPONSE_RECEIVED: {
      if (isPricePulseQueryResponseAction(action)) {
        const newById = byId(state.byId, action);
        if (newById === state.byId) return state;
        return { byId: newById };
      }
      return state;
    }
    case SEARCH_PARAMS_CHANGED:
      return INITIAL_STATE;
    default:
      return state;
  }
};
